import { Rect } from '../shapes/index';
/** Stable key for batching nodes with identical paint styles. */
export function paintStyleKey(node) {
    var fill = node.fill === null || node.fill === undefined
        ? ''
        : typeof node.fill === 'string'
            ? node.fill
            : JSON.stringify(node.fill);
    var stroke = node.stroke === null || node.stroke === undefined
        ? ''
        : typeof node.stroke === 'string'
            ? node.stroke
            : JSON.stringify(node.stroke);
    return "".concat(fill, "|").concat(stroke, "|").concat(node.strokeWidth, "|").concat(node.dash.join(','), "|").concat(node.lineCap, "|").concat(node.lineJoin);
}
/** Rect eligible for fill batching (simple transforms, no effects). */
export function isBatchableRect(node) {
    return (node instanceof Rect &&
        !node.clip &&
        !node.mask &&
        !node.shadow &&
        node.rotation === 0 &&
        node.skewX === 0 &&
        node.skewY === 0 &&
        node.scaleX === 1 &&
        node.scaleY === 1 &&
        node.cornerRadius === 0 &&
        !node.stroke);
}
